import React from 'react';
import { getBackgroundImages } from '../SharedUtils/utils';

const screenBreakpoints = {
  large: 992,
  medium: 768,
};

const getBackgroundImage = (small, medium, large) => {
  const backgroundStyles = {};
  backgroundStyles.smallImage = small;
  backgroundStyles.mediumImage = medium;
  backgroundStyles.largeImage = large;

  return backgroundStyles;
};

const BackgroundImageStyles = ({ componentId, fields, isLight = false }) => {
  const {
    largeBackgroundImageField: largeImageField,
    mediumBackgroundImageField: mediumImageField,
    smallBackgroundImageField: smallImageField,
  } = getBackgroundImages(fields, isLight);

  const presetCombo = isLight
    ? fields.BackgroundImagePresetCombosLight
    : fields.BackgroundImagePresetCombosDark;

  let backgroundImage = getBackgroundImage(smallImageField, mediumImageField, largeImageField);

  if (presetCombo) {
    backgroundImage = getBackgroundImage(
      presetCombo.fields?.BackgroundImageSmall,
      presetCombo.fields?.BackgroundImageMedium,
      presetCombo.fields?.BackgroundImageLarge
    );
  }

  const repeat = fields.BackgroundImageRepeat?.value;
  const backgroundRepeat = repeat ? 'background-repeat: repeat;' : '';
  const backgroundColorDefault = 'background-color: transparent !important;';

  let styles = '';

  if (
    backgroundImage.largeImage?.value?.src &&
    backgroundImage.largeImage?.value?.class !== 'scEmptyImage'
  ) {
    styles += `#${componentId} { background-image: url('${backgroundImage.largeImage.value.src}'); ${backgroundRepeat} ${backgroundColorDefault} }`;
  }

  if (
    backgroundImage.mediumImage?.value?.src &&
    backgroundImage.mediumImage?.value?.class !== 'scEmptyImage'
  ) {
    styles += `@media (max-width: ${screenBreakpoints.large - 1}px) and (min-width: ${
      screenBreakpoints.medium
    }px) {
        #${componentId} {
          background-image: url('${backgroundImage.mediumImage.value.src}');
          ${backgroundColorDefault}
        }
      }`;
  }

  if (
    backgroundImage.smallImage?.value?.src &&
    backgroundImage.smallImage?.value?.class !== 'scEmptyImage'
  ) {
    styles += `@media (max-width: ${screenBreakpoints.medium - 1}px) {
        #${componentId} {
          background-image: url('${backgroundImage.smallImage.value.src}');
          ${backgroundColorDefault}
        }
      }`;
  }

  return <style>{styles}</style>;
};

export default BackgroundImageStyles;
